<ion-item-sliding *ngFor="let contract of filteredContractList; let i = index" class="">
    <ion-item lines="none">
        <div
                class="list-item-block glass-blurred-background drop-shadow"

                (click)="openContract(contract.id)"
        >
            <div [ngClass]='contract.status'></div>
            <div class="name center-content-vertical">
                {{ utenti[contract.id]?.name |titlecase }} {{ utenti[contract.id]?.lastname  |titlecase}}
            </div>
            <div class="date center-content-vertical">
                {{ contract.startDate | date: "yy" }} / {{ contract.endDate | date: "yy" }}
            </div>
            <div class="total center-content-vertical">
                {{ contract.amount | currency: "EUR" }}
            </div>
            <div class="product center-content-vertical">
                {{ contract.commercial?.name }} {{ contract.commercial?.lastname }}
            </div>
        </div>

    </ion-item>
    <ion-item-options [ngSwitch]="contract.status" class="ion-padding-bottom">

        <!--  <ion-item-option color="secondary" (click)="proroga(contract.id)">Proroga</ion-item-option> -->
        <ng-container  *ngIf="sessionService.user?.permessions === sessionService.permissionType.COMMERCIAL ||sessionService.user?.permessions === sessionService.permissionType.ADMINISTRATOR ">
            <ion-item-option (click)="changeStatus(contract,contractStatus.TOVERIFY)" *ngSwitchCase="contractStatus.DRAFT"
            >Verifica</ion-item-option>
        </ng-container>
        <ng-container  *ngIf="sessionService.user?.permessions === sessionService.permissionType.ADMINISTRATOR ">
            <ion-item-option (click)="changeStatus(contract,contractStatus.TOBEPAYED)" *ngSwitchCase="contractStatus.TOVERIFY"
            >Verificato</ion-item-option>
        </ng-container>
        <ng-container  *ngIf="sessionService.user?.permessions === sessionService.permissionType.COMMERCIAL ||sessionService.user?.permessions === sessionService.permissionType.ADMINISTRATOR ">
            <ion-item-option (click)="changeStatus(contract,contractStatus.PAYED)" *ngSwitchCase="contractStatus.TOBEPAYED"
            >{{contractStatus.PAYED}}</ion-item-option>
        </ng-container>

        <ng-container  *ngIf="sessionService.user?.permessions === sessionService.permissionType.ADMINISTRATOR ">
            <ion-item-option (click)="changeStatus(contract,contractStatus.ACTIVE)" *ngSwitchCase="contractStatus.PAYED"
            >{{contractStatus.ACTIVE}}</ion-item-option>
        </ng-container>
        <ng-container  *ngIf="sessionService.user?.permessions === sessionService.permissionType.ADMINISTRATOR ">
            <ion-item-option (click)="proroga(contract.id)" *ngSwitchCase="contractStatus.ACTIVE"
            >Proroga</ion-item-option>
        </ng-container>

    </ion-item-options>
</ion-item-sliding>


<div class="floating-btn drop-shadow" (click)="addContract()">+</div>
